// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarAdmin_navbar__AuyK5","logo":"NavbarAdmin_logo__RGGes","navLinks":"NavbarAdmin_navLinks__GJ5w1","navItem":"NavbarAdmin_navItem__h7+AZ"};